import React from "react";
import { Plan } from "../../../@types";
import { useTranslate } from "../../../helpers/intlHooks";
import { addProtocolToUrl } from "../../../helpers/objectUtilities";
import { EnrollButtonForm } from "../../../components";
import { isCurrentPlan, PreviewContext } from "../../../helpers";
import { AppStore } from "../../../app/store";

export const PlanContact: React.FunctionComponent<{ plan: Plan }> = ({
  plan,
}) => {
  const memberPhone = plan.member_phone && plan.member_phone.number;
  const nonMemberPhone = plan.prospect_phone && plan.prospect_phone.number;

  const t = useTranslate();
  const previewMode = React.useContext(PreviewContext);
  const {
    state: { currentCoverage },
  } = React.useContext(AppStore.AppContext);
  const currentPlan = isCurrentPlan(currentCoverage, plan);

  return (
    <div className="PlanDetailsPagePlanContact">
      <div className="PlanDetailsPagePlanContact__leftCol">
        <div className="PlanDetailsPagePlanContact__leftColCell">
          <a
            href={addProtocolToUrl(plan.url)}
            target="_blank"
            rel="noopener noreferrer"
            className="preview-disable-exempt PlanDetailsPagePlanContact__link ds-c-button mct-c-button--ghost"
            id="plan-contact"
          >
            {t("plan_details.header.plan_website")}
          </a>
        </div>
        <div className="PlanDetailsPagePlanContact__leftColCell">
          <span
            className="ds-u-font-weight--bold PlanDetailsPagePlanContact__leftColCell-label"
            id="non-members-label"
          >
            {t("plan_terms.non_members")}:{" "}
          </span>
          <span
            className="ds-u-visibility--screen-reader"
            id="non-members-phone"
          >
            {t("phone_number")}
          </span>
          <a
            id="non-members-number"
            className="PlanDetailsPagePlanContact__link ds-c-button mct-c-button--ghost PlanDetailsPagePlanContact__telephone"
            href={`tel:${nonMemberPhone}`}
            aria-labelledby="non-members-label non-members-phone non-members-number"
          >
            {nonMemberPhone}
          </a>
        </div>
        <div className="PlanDetailsPagePlanContact__leftColCell">
          <span
            className="ds-u-font-weight--bold PlanDetailsPagePlanContact__leftColCell-label"
            id="members-label"
          >
            {t("plan_terms.members")}:{" "}
          </span>
          <span className="ds-u-visibility--screen-reader" id="members-phone">
            {t("phone_number")}
          </span>
          <a
            id="members-number"
            className="PlanDetailsPagePlanContact__link ds-c-button mct-c-button--ghost PlanDetailsPagePlanContact__telephone"
            href={`tel:${memberPhone}`}
            aria-labelledby="members-label members-phone members-number"
          >
            {memberPhone}
          </a>
        </div>
      </div>
      <div className="PlanDetailsPagePlanContact__rightCol">
        {!previewMode && !currentPlan && (
          <EnrollButtonForm
            buttonClassName="PlanDetailsPagePlanContact__enrollButton"
            plan={plan}
            tealiumEventAction="Plan Details"
          />
        )}
      </div>
    </div>
  );
};
